// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"110":"7131be98","211":"3a68c04a","321":"aa6ca439","352":"3bd633cb","453":"20359781","557":"9acd8978","566":"b5eebba2","676":"e2871c3b","796":"b8dac7a6"}[chunkId] + ".chunk.js";
};